const { userConstant } = require("./constant");

export const renderAction = (data) => ({
    type: userConstant.IS_RENDER,
    payload: data
})